<script lang="ts">
  import { Accordion, AccordionItem, Card, Col, Image } from "sveltestrap";
  import { ActivityFeed, href } from "../../../utils/Constant/Constant";
  import data from "../../../Data/SocialApp/SocialApp.json"
  import Link from "svelte-link";
  let imgPath:string = "/assets/images/user"
</script>
<Col xl="12">
    <Card>
        <Accordion>
            <AccordionItem active header={ActivityFeed}>
                <div class="collapse show" >
                    <div class="social-status filter-cards-view">
                        {#each data.activityfeeddata as activityItem}
                            <div class="media">
                                <Image class="img-50 rounded-circle m-r-15" src="{imgPath}/{activityItem.img}" />
                                <div class="media-body">
                                    <span class="f-w-600 d-block">{activityItem.name}</span>
                                    <p>{activityItem.title} 
                                        <Link href={href}>{activityItem.Photo}</Link>
                                    </p>
                                    <span class="light-span">{activityItem.time}</span>
                                </div>
                            </div>
                        {/each}
                    </div>
                </div>
            </AccordionItem>
        </Accordion>
    </Card>
</Col>